module.exports = __webpack_public_path__ + "static/contract-hire-a7fdbbec5837c135a785da7dca11df4a.jpg";